import { useRouter } from 'next/router';
import URI from 'urijs';
import { appQueryParameters } from '@clubmed/utils';
import { clearAllCacheFront } from 'Utils/graphql-client/cacheFront';
export const useLayer = (layerName: string, params: any = {}, uri?: string) => {
  const router = useRouter();
  const { query } = router;
  const isLayerOpened = query?.[appQueryParameters.openLayer] === layerName;
  const nextUri = new URI(uri ? uri : router.asPath)
    .addQuery({
      [appQueryParameters.openLayer]: layerName,
      ...params,
    })
    .hash('');

  const openLayer = (e?: React.SyntheticEvent<any>) => {
    e?.preventDefault();
    router.push(nextUri.resource(), undefined, {
      shallow: true,
    });
  };

  const cleanUrl = (path) => {
    return new URI(path)
      .clone()
      .removeSearch([appQueryParameters.openLayer, ...Object.keys(params)])
      .resource();
  };

  const closeLayer = (forceRefreshOnClose?: boolean) => {
    const newUri = cleanUrl(router.asPath);

    if (forceRefreshOnClose) {
      clearAllCacheFront();
      window.location = newUri;
    } else {
      router.push(newUri, undefined, {
        shallow: true,
      });
    }
  };

  return {
    closeLayer,
    isLayerOpened,
    nextUri,
    openLayer,
  };
};
